// Helper functions for component type determination
export const getComponentType = (item, selectedChartType) => {
  if (item.type) {
    return item.type;
  }
  
  // Otherwise determine type based on the selected chart type
  switch (selectedChartType) {
    case 'line':
      return 'line';
    case 'area':
      return 'area';
    case 'stacked-bar':
    case 'horizontal-stacked-bar':
      // For stacked charts, return bar with stackId
      return 'bar';
    case 'vertical-bar':
    case 'horizontal-bar':
    default:
      return 'bar';
  }
};

export const getStackId = (item, selectedChartType) => {
  // If item already has a stackId, use that
  if (item.stackId) {
    return item.stackId;
  }
  
  // Apply stackId for stacked chart types
  if (selectedChartType === 'stacked-bar' || selectedChartType === 'horizontal-stacked-bar') {
    return 'stack1'; // Default stack group
  }
  
  // No stacking for other chart types
  return undefined;
}; 